var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"useCoupon"}},[_c('kendo-grid',{ref:"grid",attrs:{"auth":true,"columns":_vm.tableFields,"dataUrl":_vm.tableUrl,"options":_vm.tableOptions,"size":'none',"message":'쿠폰 사용 내역이 없습니다.'}}),_vm._v(" "),_c('fab',{attrs:{"linkList":_vm.fabLinkList},on:{"download":function($event){_vm.download()}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42cbb9f4","hasScoped":false,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/admin/UseCoupon.vue
// module id = 1175
// module chunks = 1